import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';


@Injectable({
  providedIn: 'root',
})
export class MaintenanceGuard  implements CanActivate, CanActivateChild {
  private readonly EXEMPT_PATHS = ['/user/contact-us', '/maintenance'];

  constructor(private router: Router) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.checkMaintenance(state.url);
  }

  canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.checkMaintenance(state.url);
  }
  private checkMaintenance(url: string): boolean {
    const isExempt = this.EXEMPT_PATHS.some(path => url.startsWith(path));
    if (isExempt) {
      return true;
    }
    this.router.navigate(['/maintenance']);
    return false;
  }
}
